module.exports = __webpack_public_path__ + "static/media/file-pdf.69651bd3.svg";